/* eslint-disable class-methods-use-this */
import { Requests } from '@nx-smartmonkey/shared/helpers';
import { WhatsAppRepository } from './WhatsAppRepository';

export class WhatsAppRepositoryApi implements WhatsAppRepository {
  constructor(private requests: Requests) {}
  async createWhatsAppSender({
    subaccountName,
    phone,
    wabaId,
    name,
    address,
    logoUrl,
    description,
    about,
    emails,
    websites,
  }: {
    subaccountName: string;
    phone: string;
    wabaId: string;
    name: string;
    address?: string;
    logoUrl?: string;
    description?: string;
    about?: string;
    emails?: string[];
    websites?: string[];
  }): Promise<void> {
    await this.requests.post({
      uri: `/planner/v1/whatsapp/sender`,
      data: {
        subaccount_name: subaccountName,
        phone,
        waba_id: wabaId,
        name,
        address,
        logo_url: logoUrl,
        description,
        about,
        emails,
        websites,
      },
    });
  }

  async retrieveMetaPhone({
    phone_id,
    code,
    auth_token,
    redirect_uri,
  }: {
    phone_id: string;
    code?: string;
    auth_token?: string;
    redirect_uri: string;
  }): Promise<string> {
    const response = await this.requests.get({
      uri: `/planner/v1/whatsapp/phone`,
      params: { phone_id, code, auth_token, redirect_uri },
    });

    return response.data;
  }
}
